<h3>
  <strong>Nyitvatartás</strong>
</h3>

<p>
  <strong>Hétköznap:</strong>&nbsp;
  <em>9:00–19:00</em>
  <br />

  <strong>Hétvégén:</strong>&nbsp;
  <em>10:00–14:00</em>

  <br />
  <br />

  115 Avenue A
  <br />

  New York, NY 10009
  <br />

  212-256-0076
</p>

<button
  type="button"
  class="bf-button"
  (click)="toast.show('Coming soon')"
>
  Időpontfoglalás
</button>
